module.exports = __webpack_public_path__ + "montserrat-v13-cyrillic_latin-900.woff2?0e12fdc10d4eb4694e78a618a931947c";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/montserrat-v13-cyrillic_latin-900.woff2
// module id = 17
// module chunks = 0